import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ContactBoxInCartConverter extends CmsConverterService<ContactBoxInCartData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const CONTACT_BOX_IN_CART_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ContactBoxInCartData>>('ContactBoxInCartConverter')

export type ContactBoxInCartData = ConvertedComponentData
